import React from "react";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Stack } from "@altimateai/lego";

interface StrengthsWeaknessesProps {
  strengths?: string[];
  weaknesses?: string[];
  isCompact: boolean;
}

export const StrengthsWeaknesses: React.FC<StrengthsWeaknessesProps> = ({
  strengths,
  weaknesses,
  isCompact,
}) => {
  const hasStrengths = strengths && strengths.length > 0;
  const hasWeaknesses = weaknesses && weaknesses.length > 0;
  if (!hasStrengths && !hasWeaknesses) return null;
  const textSize = isCompact ? "al-text-xs" : "al-text-sm";

  return (
    <div
      className={`al-grid ${isCompact ? "al-grid-cols-2 al-gap-2" : "al-grid-cols-1 md:al-grid-cols-2 al-gap-4"}`}
    >
      {hasStrengths && (
        <div>
          <div
            className={`al-text-xs al-font-semibold al-text-green-700 al-uppercase ${isCompact ? "al-mb-1" : "al-mb-2"}`}
          >
            ✓ Strengths
          </div>
          <ul className={isCompact ? "al-space-y-0.5" : "al-space-y-2"}>
            {strengths.map((strength: string, i: number) => (
              <Stack
                key={i}
                direction="row"
                align="start"
                className={`${textSize} al-text-gray-700`}
              >
                <li>
                  <IconCheck
                    className={`${isCompact ? "al-w-3 al-h-3 al-mr-1 al-mt-0.5" : "al-w-4 al-h-4 al-mr-2 al-mt-0.5"} al-text-green-600 al-flex-shrink-0`}
                  />
                  <span className="al-break-words">{strength}</span>
                </li>
              </Stack>
            ))}
          </ul>
        </div>
      )}
      {hasWeaknesses && (
        <div>
          <div
            className={`al-text-xs al-font-semibold al-text-red-700 al-uppercase ${isCompact ? "al-mb-1" : "al-mb-2"}`}
          >
            ✗ Weaknesses
          </div>
          <ul className={isCompact ? "al-space-y-0.5" : "al-space-y-2"}>
            {weaknesses.map((weakness: string, i: number) => (
              <li key={i} className={`${textSize} al-text-gray-700`}>
                <Stack direction="row" align="start">
                  <IconX
                    className={`${isCompact ? "al-w-3 al-h-3 al-mr-1 al-mt-0.5" : "al-w-4 al-h-4 al-mr-2 al-mt-0.5"} al-text-red-600 al-flex-shrink-0`}
                  />
                  <span className="al-break-words">{weakness}</span>
                </Stack>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
